import { environment } from '@env/environment';

import { GetRequestData } from '../utils';

export class AnalyticsApi {
  static exportKpiReport(period: string, relative: string): GetRequestData {
    return {
      url: `${environment.backendURL}/api/analytics/export/kpi-report?period=${period}&relative=${relative}`,
    };
  }

  static exportKpiReportByDateRange(startDate: string, endDate: string): GetRequestData {
    return {
      url: `${environment.backendURL}/api/analytics/export/kpi-report?startDate=${startDate}&endDate=${endDate}`,
    };
  }
}
